<template lang="pug">
.payments
  .payment
    .left
      .p-date
        .new(v-if="newPayment") NEUE ZAHLUNG
        |{{convertType(payment.type)}} - {{formatDate(payment.paymentDate)}}
      .p-total
        b-tag(:type="payment.total >= 0 ? 'is-success' : 'is-danger'" size="is-medium") {{(payment.total/100) | toCurrency}}
        .actions(v-if="!newPayment")
          b-tooltip(label='Bearbeiten' type='is-secondary' position='is-bottom' :delay="1250")
            b-button(icon-right="pencil", type="is-secondary" @click="isModalActive = true")
          .spacer.sm.inline
          b-tooltip(label='Dauerhaft löschen' type='is-danger' position='is-bottom' :delay="1250")
            b-button(icon-right="close", type="is-danger" @click="deletePayment()")
    .p-comment {{payment.comment}}

  b-modal(v-model='isModalActive' has-modal-card='' trap-focus='' :destroy-on-hide='false' aria-role='dialog' aria-modal='')
    template(#default='props')
      .form.w512
        .card.margin-top
          .top
            h2.title.is-6 Zahlung aktualisieren
            ValidationObserver(v-slot="{ handleSubmit }", ref="form")
              b-field(grouped)
                ValidationProvider(name="Zahlungsmethode" rules="required" v-slot="{ errors, valid }") 
                  b-field(label="Zahlungsmethode" label-position="on-border"
                          :type="{ 'is-danger': errors[0]}" :message="errors")
                    b-select(v-model="formData.type")
                      option(value="cash") Barzahlung
                      option(value="bankwire") Überweisung
                      option(value="creditCard") Kreditkarte
                      option(value="ecCard") EC-Karte
                .spacer.sm
                ValidationProvider(
                    name="Zahlungseingang",
                    rules="required",
                    v-slot="{ errors, valid }")
                    b-field(
                      label="Zahlungseingang",
                      label-position="on-border",
                      :type="{ 'is-danger': errors[0]}",
                      :message="errors")
                      v-date-picker(v-model="formData.paymentDate" :popover="popoverConfig")
                        template(#default='{ inputValue, inputEvents }')
                          input.input(:value='inputValue' v-on='inputEvents')
              ValidationProvider(
                name="Preis (€)",
                :rules="{ required: true, currency: /^[+-]?[0-9]{1,3}(?:,?[0-9]{3})*(\.[0-9]{2})?$/ }",
                v-slot="{ errors, valid }")
                b-field(
                  label="Preis (€)",
                  label-position="on-border",
                  :type="{ 'is-danger': errors[0]}",
                  :message="errors")
                  b-input(v-model="formData.total" ref="priceInput")
              ValidationProvider(name="Kommentar" rules="" v-slot="{ errors, valid }") 
                b-field(label="Kommentar" label-position="on-border"
                        :type="{ 'is-danger': errors[0]}" :message="errors")
                  b-input(v-model="formData.comment" type="textarea" maxlength="1000")
              .button-wrapper.margin-top.right
                b-button(
                  type="is-light",
                  @click="isModalActive = false"
                ) Abbrechen
                b-button(
                  type="is-primary",
                  @click="handleSubmit(updatePayment)"
                ) Aktualisieren
</template>

<script>
import { DateTime } from 'luxon';

export default {
  props: {
    payment: {
      type: Object
    },
    newPayment: {
      type: Boolean
    }
  },
  data() {
    return {
      isModalActive: false,
      formData: {},
      popoverConfig: {
        visibility: 'focus',
        showDelay: 0,
        hideDelay: 1,
      },
    }
  },
  mounted() {
    this.formData = JSON.parse(JSON.stringify(this.payment));
    this.formData.total = this.formData.total / 100;
    this.formData.paymentDate = DateTime.fromISO(this.formData.paymentDate).toJSDate();
  },
  methods: {
    convertType(paymentType) {
      if (paymentType === 'cash') return 'Barzahlung';
      if (paymentType === 'bankwire') return 'Überweisung';
      if (paymentType === 'creditCard') return 'Kreditkarte';
      if (paymentType === 'ecCard') return 'EC-Karte';
      return paymentType;
    },
    formatDate(d) {
      if (d instanceof Date) {
        const dt = DateTime.fromJSDate(d);
        return dt.setLocale('de')
        .toFormat("dd.LL.yyyy")
      }

      const dt = DateTime.fromISO(d);
      return dt.setLocale('de')
        .toFormat("dd.LL.yyyy")
    },
    formatJSDate(d) {
      const dt = DateTime.fromJSDate(d);
      return dt.setLocale('de')
        .toFormat("dd.LL.yyyy")
    },
    async updatePayment() {
      const centPrice = parseInt(this.formData.total.toString().replace(",", ".") * 100);
      this.formData.paymentDate = DateTime.fromJSDate(this.formData.paymentDate);
      await this.$store.dispatch("payments/update", {...this.formData, paymentDate: this.formData.paymentDate.toISODate(), total: centPrice});
      this.isModalActive = false;
      this.$emit("updatePayment");
    },
    deletePayment() {
      this.$buefy.dialog.confirm({
        title: "Zahlung löschen",
        message: `Sind Sie sicher, dass Sie diese Zahlung in Höhe von <b>${this.formData.total} €</b> löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.`,
        confirmText: "Jetzt löschen",
        cancelText: "Abbrechen",
        type: "is-danger",
        hasIcon: true,
        onConfirm: async () => {
          try {
            await this.$store.dispatch("payments/delete", {
              id: this.payment.id,
            });
            this.isModalActive = false;
            this.$emit("updatePayment");
          } catch (e) {
            //console.log(e)
          }
        },
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.payments {
  margin-bottom: $sm-space;
  .payment {
    overflow: hidden;
    padding: $xs-space;
    background-color: $light;
    border-radius: 3px;
    margin-bottom: $xs-space;
    position: relative;
    transition: all 0.24s ease;
    .left {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .p-date {
      color: $black;
      font-size: 1rem;
    }
    .p-comment {
      color: $black;
    }
    .p-total {
      // min-width: 124px;
      font-weight: 500;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
    .actions {
      transition: all 0.24s ease;
      overflow: hidden;
      margin-left: $sm-space;
      margin-right: -104px;
    }
    .new {
      display: inline-block;
      font-size: 0.6rem;
      background-color: $dark;
      border-radius: 99px;
      color: white;
      padding: 2px 4px;
      margin-right: $xs-space;
    }
    &:hover {
      .actions {
        margin-right: 0;
      }
    }
  }
}
</style>